import { useContext } from "react";
import type { GameVer } from "~/util/Lang";
import { RealmContext } from "~/util/Lang";
import css from "./Icon.module.css";

const DIRS: Record<GameVer, string> = {
  c1: "icons",
  c2: "icons-c2",
  c3: "icons-c3",
  c4: "icons-c4",
  c5: "icons-c5",
  il: "icons-gf",
  gf: "icons-gf",
};

export function Icon(props: {
  icon: string;
  alt?: string | undefined | null;
  size?: number;
  game?: GameVer;
}) {
  const realm = useContext(RealmContext);
  return (
    <img
      src={getIconUrl(props.icon, !props.game ? realm.game : props.game)}
      alt={props.alt ?? ""}
      style={
        props.size !== 32
          ? {
              width: props.size ?? 32,
              height: props.size ?? 32,
              borderRadius: 2,
              boxShadow: "0 0 0 1px rgb(0 0 0 / 35%)",
            }
          : {
              width: props.size ?? 32,
              height: props.size ?? 32,
            }
      }
    />
  );
}

export function Icon32(props: {
  icon: string;
  alt?: string | null | undefined;
  game?: GameVer;
}) {
  const realm = useContext(RealmContext);
  return (
    <img
      src={getIconUrl(props.icon, !props.game ? realm.game : props.game)}
      alt={props.alt ?? ""}
      className={css.icon32}
    />
  );
}

export function Icon24(props: {
  icon: string;
  alt?: string | null | undefined;
  canBeUsed?: boolean;
}) {
  const realm = useContext(RealmContext);
  return (
    <img
      src={getIconUrl(props.icon, realm.game)}
      alt={props.alt ?? ""}
      className={css.icon24}
      style={
        props.canBeUsed
          ? { boxShadow: "0 0 0 1px #ffc800, 0 0 4px 2px #0006" }
          : undefined
      }
    />
  );
}

export function Icon16(props: {
  icon: string;
  alt?: string | null | undefined;
}) {
  const realm = useContext(RealmContext);
  return (
    <img
      src={getIconUrl(props.icon, realm.game)}
      alt={props.alt ?? ""}
      className={css.icon16}
    />
  );
}

function getIconUrl(icon: string, gver: GameVer) {
  return `/s/${DIRS[gver]}/${icon}.png`;
}

export function getIconFullUrl(icon: string, gver: GameVer) {
  return `https://l2hub.info/s/${DIRS[gver]}/${icon}.png`;
}
